module.exports = __webpack_public_path__ + "static/RUdeskSlide1-fa0a004ec5937243da6a9597c00e2c78.png";